import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

//Tables
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../utils/MyTable';

//Utils

import { useDispatch } from "react-redux";
import UnoButton from '../utils/UnoButton';

import { Checkbox, Grid, Tooltip, Typography, withStyles } from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';
import { myLabelInput, tabs, unoTheme } from '../../assets/styles/unoTheme';

import moment, { localeData } from 'moment';
import { useMemo } from 'react';
import { MyTab, MyTabs } from '../utils/MyTabs';
import allActions from '../../actions';
import { ClientAPI } from '../../API/client';
import MyTextField from '../utils/MyTextField';
import { MAX_APR_DESCRIPTION_LENGTH } from '../utils/utils';

import AddIcon from '@material-ui/icons/Add';

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #000000"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        fontSize: '15px',
        backgroundColor: theme.palette.common.white,
        border: "1px solid #000000",
        color: "#000000"
    }
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        //alignItems: 'center',
        paddingBottom: theme.spacing(2),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: "8px",
    },

    actionsFlexRight: {
        display: 'flex',
        alignItems: 'center',
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },
    formControl: {
        //margin: theme.spacing(1), 
        width: '100%',
        textAlign: 'left'
    },
    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between'
        }

    },
    noMarginTop: {
        marginTop: "0px",
    },
    tableTh: {
        fontWeight: 'bold'
    },
    assetsToCreateRow: {
        '& .MuiTableCell-root': {
            fontSize: '12px !important',
        }
    },
    green: {
        color: unoTheme.greenMoney,
    },
    red: {
        color: unoTheme.redMoney,
    },
    blue: {
        color: "blue",
    },
    warningColor: {
        color: unoTheme.warningColor
    },
    label: myLabelInput,
    afirmativeText: {
        color: 'black'
    },
    noPaddingLeft: {
        paddingLeft: '0px',
    },
    noPaddingRight: {
        paddingRight: '0px !important',
    },

    progress: {
        color: unoTheme.mainColor,
        textAlign: 'center',
        height: "100%",
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
        '& .MuiCircularProgress-root': {
            width: '25px !important',
            height: '25px !important',
        },

        '& h6': {
            fontSize: '14px !important',
        }
    },

    labelTopModal: {
        float: 'right',
        fontSize: '14px',
        color: unoTheme.defaultTextColor
    },

    tabs: tabs,
    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    ellipsis: {
        whiteSpace: "nowrap", /* Impede a quebra de linha */
        overflow: "hidden", /* Garante que o texto extra seja ocultado */
        textOverflow: "ellipsis",
    },


}));

export default function ManageAprDescriptionsModal(props) {

    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();

    const { open, clientId,
        handleClose, handleUpdateDescriptions } = props;

    const [loader, setLoader] = useState("");
    const [message, setMessage] = useState("");

    const [tabValue, setTabValue] = useState(0);
    const [aprDescriptions, setAprDescriptions] = useState(null);

    const clearToUpdate = () => {
        const newCheckeds = [...aprDescriptions]
        newCheckeds.forEach((el) => {
            el.toUpdate = false;
        })
        setAprDescriptions(newCheckeds);
    }
    const handleChangeTabValue = (event, newValue) => {

        clearToUpdate();
        setTabValue(newValue);
    };

    const handleCheckDescription = (event, descriptionId) => {

        if (message) {
            setMessage("");
        }
        const newCheckeds = [...aprDescriptions]
        const foundDescrption = newCheckeds.find(el => el.id == descriptionId);
        if (foundDescrption) {
            foundDescrption.toUpdate = event.target.checked;
            setAprDescriptions(newCheckeds);
        }
    }

    const enableInactiveButton = useMemo(() => {

        if (!aprDescriptions) return false;
        if (aprDescriptions.filter(el => el.active && el.toUpdate).length) return true;
        return false;
    }, [aprDescriptions])

    const enableActiveButton = useMemo(() => {

        if (!aprDescriptions) return false;
        if (aprDescriptions.filter(el => !el.active && el.toUpdate).length) return true;
        return false;
    }, [aprDescriptions])

    const doActiveDesriptions = async () => {

        setLoader("Ativando descrições...")
        const inactivesToActive = aprDescriptions.filter(el => !el.active && el.toUpdate);
        console.log("ativar descrições: ", inactivesToActive);


        for (let index = 0; index < inactivesToActive.length; index++) {
            const element = inactivesToActive[index];

            await ClientAPI.updateAprDescriptionActivation(element.id, true);
        }
        clearToUpdate();
        loadDescriptions(clientId)
        setMessage("Descrições ativadas com sucesso!");
        setLoader("");

    }

    const doInactiveDesriptions = async () => {

        setLoader("Desativando descrições...")
        const activesToInactive = aprDescriptions.filter(el => el.active && el.toUpdate);
        console.log("inativar descrições: ", activesToInactive);

        for (let index = 0; index < activesToInactive.length; index++) {
            const element = activesToInactive[index];

            await ClientAPI.updateAprDescriptionActivation(element.id, false);
        }
        clearToUpdate();
        loadDescriptions(clientId)
        setMessage("Descrições inativadas com sucesso!");
        setLoader("");

    }

    const loadDescriptions = async (clientId) => {
        handleUpdateDescriptions();
        const response = await ClientAPI.listAprDescriptions(clientId);
        if (response.success) {

            setAprDescriptions(response.body.rows)
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "error",
                message: "Falha ao obter descrições!"
            }))
        }
    }

    //Register new apr description
    const [registerDescriptionNewApw, setDescriptionRegisterNewApw] = useState("");
    const [inputTitleNewAprDescription, setInputTitleNewAprDescription] = useState("");
    const [inputAreaNewAprDescription, setInputAreaNewAprDescription] = useState("");

    function handleChangeTitleNewApr(value) {
        setInputTitleNewAprDescription(value)
    }

    function handleChangeAreaNewApr(value) {

        setInputAreaNewAprDescription(value.substring(0, MAX_APR_DESCRIPTION_LENGTH))
        if (value.length > MAX_APR_DESCRIPTION_LENGTH) {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "warning",
                message: `O texto de descrição de APR deve possuir no máximo ${MAX_APR_DESCRIPTION_LENGTH} caracteres`
            }))
        }
    }

    const [submittedNewApr, setSubmittedNewApr] = useState(false);

    const clearRegisterNewDescription = () => {
        setInputTitleNewAprDescription("");
        setInputAreaNewAprDescription("");
        setSubmittedNewApr(false);
        setDescriptionRegisterNewApw(false);
    }

    async function doSaveDescriptionApr(clientId) {

        setLoader("Cadastrando nova descrição...")
        setSubmittedNewApr(true);

        if (inputTitleNewAprDescription != "" && inputAreaNewAprDescription != "") {
            let response = await ClientAPI.saveNewAprDescription(clientId,
                inputTitleNewAprDescription,
                inputAreaNewAprDescription);

            if (response.success) {

                clearRegisterNewDescription();
                setMessage('Descrição cadastrada com sucesso!')

            } else {

                setSubmittedNewApr(false);
                setMessage('Erro ao salvar texto padrão para APR')
            }

        }

        loadDescriptions(clientId);
        setLoader("")


    }

    useEffect(() => {
        if (!open || !clientId) return;

        loadDescriptions(clientId)
        //loadInfos();
    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            open={open}
            PaperProps={{
                style: {
                    height: '90vh', // 80% da altura da viewport
                },
            }}
            onClose={() => handleClose()}>
            <DialogTitle
                className={classes.dialogTitle}>
                {

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>

                        <div>Gerenciamentos de descrições padrão</div>
                        {
                            !registerDescriptionNewApw &&
                            <UnoButton
                                size="small"
                                color='primary'
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    setMessage("");
                                    setDescriptionRegisterNewApw(true)
                                }}>
                                {'Criar Texto Padrão'}
                            </UnoButton>
                        }
                    </div>

                }

            </DialogTitle>

            <DialogContent
                className={classes.contentModal}>

                {
                    loader ?
                        <div className={classes.progress}>
                            <CircularProgress
                                disableShrink color="inherit" />
                            <Typography variant={"h6"}>
                                {loader}
                            </Typography>
                        </div>
                        :
                        <>

                            {
                                registerDescriptionNewApw ?
                                    <div className={'subMain'}>
                                        <Grid container spacing={2}>
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <MyTextField
                                                    labelclassname={classes.noMarginTop}
                                                    value={inputTitleNewAprDescription}
                                                    onChange={handleChangeTitleNewApr}
                                                    variant="outlined"
                                                    margin="dense"
                                                    outerlabel={'Título'}
                                                    type="text"
                                                    validator={inputTitleNewAprDescription == "" && submittedNewApr}
                                                    placeholder="Insira um título"
                                                    helperText="O título deve ser preenchido"
                                                    id="inputTitleNewAprDescription"
                                                    fullWidth />
                                            </Grid>

                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                <MyTextField
                                                    value={inputAreaNewAprDescription}
                                                    onChange={handleChangeAreaNewApr}
                                                    variant="outlined"
                                                    multiline={true}
                                                    rows={5}
                                                    rowsMax={5}
                                                    margin="dense"
                                                    outerlabel={'Descrição'}
                                                    placeholder="Insira a descrição da APR"
                                                    validator={inputAreaNewAprDescription == "" && submittedNewApr}
                                                    helperText="Uma descrição deve ser fornecida"
                                                    type="text"
                                                    id="inputAreaNewAprDescription"
                                                    fullWidth />

                                                <span style={{ float: 'right', fontSize: '12px' }}>Caracteres {inputAreaNewAprDescription.length}/{MAX_APR_DESCRIPTION_LENGTH}</span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                    :
                                    // Abas com aprs ativas e inativas
                                    <>
                                        <div className={[classes.tabs, classes.shortWidthTab].join(' ')} style={{ width: "auto" }}>

                                            <MyTabs
                                                value={tabValue}
                                                indicatorColor="primary"
                                                textColor="primary"
                                                onChange={handleChangeTabValue}>

                                                <MyTab label={`Ativos [${aprDescriptions?.filter(el => el.active).length}]`} />
                                                <MyTab label={`Inativos [${aprDescriptions?.filter(el => !el.active).length}]`} />

                                            </MyTabs>

                                        </div>
                                        <div style={{ height: "calc(100% - 72px)" }}>

                                            {
                                                tabValue === 0 &&
                                                <MyTable
                                                    style={{ marginTop: '8px' }}
                                                    stickyHeader
                                                    sizeheaders="verySmall"
                                                    size="small">

                                                    <colgroup>
                                                        <col width="5%" />
                                                        <col width="60%" />
                                                        <col width="20%" />
                                                        <col width="15%" />
                                                    </colgroup>

                                                    <TableHead>
                                                        <TableRow>

                                                            <TableCell align="center" className='noPaddingCell'>
                                                            </TableCell>
                                                            <TableCell className={classes.tableTh} align="left">Título</TableCell>
                                                            <TableCell className={classes.tableTh} align="left">Descrição</TableCell>
                                                            <TableCell className={classes.tableTh} align="center">Criação</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {
                                                            //content.data.transactions.map((row, index) => (
                                                            aprDescriptions?.filter(el => el.active).map((row, index) => (


                                                                <TableRow className={classes.detailRow}
                                                                    key={'assets-to-update-' + index}>

                                                                    <TableCell align="center" className='noPaddingCell'>
                                                                        <Checkbox
                                                                            checked={row.toUpdate === true}
                                                                            color="primary"
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onChange={(e) => {
                                                                                handleCheckDescription(e, row.id)
                                                                            }}
                                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell align="left" className={classes.ellipsis}>
                                                                        <LightTooltip
                                                                            title={row.title}
                                                                            placement="top-start" arrow>
                                                                            <span>{row.title}</span>
                                                                        </LightTooltip>

                                                                    </TableCell>
                                                                    <TableCell align="left" className={classes.ellipsis}>
                                                                        <LightTooltip
                                                                            title={row.description}
                                                                            placement="left-start" arrow>
                                                                            <span>{row.description}</span>
                                                                        </LightTooltip>
                                                                    </TableCell>
                                                                    <TableCell align="center" className={classes.ellipsis}>{moment.utc(row.created_date).format("DD/MM/YYYY")}</TableCell>

                                                                </TableRow>

                                                            ))

                                                        }
                                                    </TableBody>

                                                </MyTable>
                                            }

                                            {
                                                tabValue === 1 &&
                                                <MyTable
                                                    style={{ marginTop: '8px' }}
                                                    stickyHeader
                                                    sizeheaders="verySmall"
                                                    size="small">

                                                    <colgroup>
                                                        <col width="5%" />
                                                        <col width="60%" />
                                                        <col width="20%" />
                                                        <col width="15%" />
                                                    </colgroup>

                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" className='noPaddingCell'>
                                                            </TableCell>
                                                            <TableCell className={classes.tableTh} align="left">Título</TableCell>
                                                            <TableCell className={classes.tableTh} align="left">Descrição</TableCell>
                                                            <TableCell className={classes.tableTh} align="center">Criação</TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {
                                                            //content.data.transactions.map((row, index) => (
                                                            aprDescriptions?.filter(el => !el.active).map((row, index) => (


                                                                <TableRow className={classes.detailRow}
                                                                    key={'assets-titles-to-update-' + index}>

                                                                    <TableCell align="center" className='noPaddingCell'>
                                                                        <Checkbox
                                                                            checked={row.toUpdate === true}
                                                                            color="primary"
                                                                            onClick={(e) => e.stopPropagation()}
                                                                            onChange={(e) => {
                                                                                handleCheckDescription(e, row.id)
                                                                            }}
                                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell align="left" className={classes.ellipsis}>
                                                                        <LightTooltip
                                                                            title={row.title}
                                                                            placement="top-start" arrow>
                                                                            <span>{row.title}</span>
                                                                        </LightTooltip>

                                                                    </TableCell>
                                                                    <TableCell align="left" className={classes.ellipsis}>
                                                                        <LightTooltip
                                                                            title={row.description}
                                                                            placement="left-start" arrow>
                                                                            <span>{row.description}</span>
                                                                        </LightTooltip>
                                                                    </TableCell>
                                                                    <TableCell align="center" className={classes.ellipsis}>{moment.utc(row.created_date).format("DD/MM/YYYY")}</TableCell>

                                                                </TableRow>

                                                            ))

                                                        }
                                                    </TableBody>

                                                </MyTable>
                                            }

                                        </div>
                                    </>
                            }




                        </>
                }


            </DialogContent>


            {
                !loader ?
                    <>

                        <DialogActions className={classes.actionsFlex}>

                            <div style={{ flex: 1 }}>

                                {
                                    registerDescriptionNewApw ?

                                        <UnoButton onClick={() =>

                                            clearRegisterNewDescription()} color="secondary">
                                            {'Voltar'}
                                        </UnoButton>
                                        :
                                        <UnoButton onClick={() =>
                                            handleClose()} color="secondary">
                                            {'Fechar'}
                                        </UnoButton>
                                }
                            </div>

                            {/* <UnoButton
                                className={classes.spaceRight2}
                                onClick={(e) => handleAction(e, false)}
                                color="primary">
                                {'Não atualizar'}
                            </UnoButton> */}
                            {
                                enableActiveButton && !registerDescriptionNewApw &&
                                <UnoButton
                                    className={classes.spaceRight2}
                                    onClick={(e) => doActiveDesriptions()}
                                    type="success">
                                    {'Ativar descrições'}
                                </UnoButton>
                            }
                            {
                                enableInactiveButton && !registerDescriptionNewApw &&
                                <UnoButton
                                    className={classes.spaceRight2}
                                    onClick={(e) => doInactiveDesriptions()}
                                    type="success">
                                    {'Desativar descrições'}
                                </UnoButton>
                            }

                            {
                                registerDescriptionNewApw &&
                                <UnoButton
                                    className={classes.spaceRight2}
                                    onClick={(e) => doSaveDescriptionApr(clientId)}
                                    type="primary">
                                    {'Salvar descrição'}
                                </UnoButton>
                            }

                            {
                                message &&
                                <Typography style={{ color: "green" }}>{message}</Typography>
                            }

                        </DialogActions>

                    </>
                    : null

            }




        </Dialog >
    );
}